<template>
  <v-container fluid class="profile-page pa-2 pa-sm-4 pa-md-6">
    <div class="profile-heading mb-5">
      <div>
        <div class="profile-kicker">ADMINISTRACIÓN</div>
        <h1 class="profile-title">Mi perfil</h1>
        <p class="profile-subtitle mb-0">Información de la cuenta con la que ingresaste al panel.</p>
      </div>
    </div>

    <v-skeleton-loader v-if="loading" type="card" max-width="760" />

    <v-alert v-else-if="errorMessage" type="error" text>
      {{ errorMessage }}
    </v-alert>

    <v-row v-else-if="user">
      <v-col cols="12" lg="8">
        <v-card outlined class="profile-card">
          <div class="profile-summary">
            <div class="profile-avatar">{{ initials }}</div>
            <div class="profile-summary-copy">
              <h2>{{ user.name || 'Usuario' }}</h2>
              <p>{{ user.email || 'Sin correo informado' }}</p>
              <div class="profile-status"><span></span> Sesión activa</div>
            </div>
          </div>

          <v-divider />

          <div class="profile-details">
            <div class="detail-block">
              <div class="detail-label">Nombre</div>
              <div class="detail-value">{{ user.name || '—' }}</div>
            </div>
            <div class="detail-block">
              <div class="detail-label">Correo electrónico</div>
              <div class="detail-value detail-email">{{ user.email || '—' }}</div>
            </div>
            <div class="detail-block detail-block-full">
              <div class="detail-label">Roles</div>
              <div v-if="roles.length" class="role-list">
                <v-chip v-for="rol in roles" :key="rol.id || rol.nombre" small outlined class="mr-2 mb-2">
                  {{ rol.nombre }}
                </v-chip>
              </div>
              <div v-else class="detail-value">Sin roles informados</div>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" lg="4">
        <v-card outlined class="profile-side-card">
          <div class="side-icon"><v-icon color="#111111">mdi-view-dashboard-outline</v-icon></div>
          <h3>Panel de administración</h3>
          <p>Desde acá podés gestionar el contenido y la configuración disponible para esta instalación.</p>
          <v-btn outlined block color="#111111" to="/admin/configuracion-sitio" class="profile-cta">
            Configuración del sitio
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import authService from '../../service/AuthService';

export default {
  name: 'PerfilView',

  data() {
    return {
      user: null,
      loading: true,
      errorMessage: '',
    };
  },

  computed: {
    roles() {
      return this.user && Array.isArray(this.user.roles) ? this.user.roles : [];
    },

    initials() {
      const name = this.user && this.user.name ? this.user.name.trim() : '';
      if (!name) return 'U';
      return name
        .split(/\s+/)
        .slice(0, 2)
        .map((part) => part.charAt(0).toUpperCase())
        .join('');
    },
  },

  mounted() {
    this.getPerfil();
  },

  methods: {
    async getPerfil() {
      this.loading = true;
      this.errorMessage = '';

      try {
        const { data } = await authService.perfil();
        this.user = data;
      } catch (error) {
        this.errorMessage = 'No se pudo cargar la información del perfil.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.profile-page {
  width: 100%;
  max-width: 1180px;
  min-width: 0;
  margin: 0 auto;
  text-align: left;
}

.profile-kicker {
  color: #777777;
  font-size: .7rem;
  font-weight: 800;
  letter-spacing: .14em;
}

.profile-title {
  margin: 4px 0 3px;
  color: #171717;
  font-size: 1.7rem;
  line-height: 1.2;
}

.profile-subtitle {
  color: #777777;
  font-size: .88rem;
}

.profile-card,
.profile-side-card {
  border-radius: 14px !important;
  border-color: #dedede !important;
  background: #ffffff !important;
}

.profile-summary {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 26px;
}

.profile-avatar {
  width: 66px;
  height: 66px;
  flex: 0 0 66px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #171717;
  color: #ffffff;
  font-size: 1.2rem;
  font-weight: 800;
}

.profile-summary-copy h2 {
  margin: 0;
  color: #171717;
  font-size: 1.22rem;
}

.profile-summary-copy p {
  margin: 4px 0 8px;
  color: #777777;
  font-size: .85rem;
  overflow-wrap: anywhere;
}

.profile-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #555555;
  font-size: .76rem;
}

.profile-status span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #4c9b62;
}

.profile-details {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
  padding: 25px 26px 28px;
}

.detail-block-full {
  grid-column: 1 / -1;
}

.detail-label {
  margin-bottom: 5px;
  color: #999999;
  font-size: .7rem;
  font-weight: 700;
  letter-spacing: .04em;
  text-transform: uppercase;
}

.detail-value {
  color: #222222;
  font-size: .92rem;
  font-weight: 600;
}

.detail-email {
  overflow-wrap: anywhere;
}

.profile-side-card {
  height: 100%;
  padding: 25px;
}

.side-icon {
  width: 43px;
  height: 43px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eeeeee;
  margin-bottom: 18px;
}

.profile-side-card h3 {
  margin: 0 0 8px;
  color: #171717;
  font-size: 1rem;
}

.profile-side-card p {
  color: #777777;
  font-size: .82rem;
  line-height: 1.5;
}

.profile-cta {
  margin-top: 16px;
  text-transform: none !important;
  border-radius: 8px !important;
}

@media (max-width: 600px) {
  .profile-page {
    padding: 8px 4px !important;
  }

  .profile-title {
    font-size: 1.45rem;
  }

  .profile-summary {
    align-items: flex-start;
    padding: 20px 17px;
  }

  .profile-avatar {
    width: 52px;
    height: 52px;
    flex-basis: 52px;
    font-size: 1rem;
  }

  .profile-details {
    grid-template-columns: minmax(0, 1fr);
    gap: 19px;
    padding: 20px 17px 22px;
  }

  .detail-block-full {
    grid-column: auto;
  }

  .profile-side-card {
    padding: 20px 17px;
  }
}
</style>
